import store from '@/store/index';
import { callApp } from '@/utils/app/callApp.js';
import { getTokenFromCookie, getUserFromCookie } from '@/utils/auth/cookies';

export function checkAuth() {
  const auth = store.getters.IS_AUTHENTICATED;
  if (!auth) {
    if (
      getUserFromCookie() !== null &&
      getTokenFromCookie('authToken') !== null &&
      getTokenFromCookie('userKey') !== null &&
      getTokenFromCookie('sessionToken') !== null
    ) {
      // store만 비었을때 쿠키에서 다시 로드
      store.commit('SET_STATE_TOKEN_FROM_COOKIE');
      return true;
    } else {
      // 쿠키 없을때 앱에 요청
      callApp.validateSession();
      return false;
    }
  } else {
    console.log('auth ooo');
    return true;
  }
}
